import { faLock } from "components/icon-library";
import { StyledLock } from "./lock.styles";

const Lock = () => {
  return <StyledLock icon={faLock} />;
};

export default Lock;
